module.exports = {
  single: {
    sampleFilePath: '@/utils/singleProductExcelSample.xlsx',
    resultFilePath: './단독발송_테스트파일입니다.xlsx',
    sampleSheetName: '5913.제이오비즈_스위스밀리터리_마사지기',
    messageContentCell: 'C3',
    companyContactCell: 'A1',
    customerCompanyCell: 'B1',
    moldImageId: 0
  },

  bundle: {
    sampleFilePath: './묶음발송 샘플 (1).xlsx',
    resultFilePath: './묶음발송_테스트파일입니다.xlsx',
    resultSheetName: '언어검토 양식_기존',

    imageWidth: 279.685,
    imageHeight: 279.685,

    location: {
      title: { row: 2, column: 5 },
      name: { row: 4, column: 4 },
      price: { row: 5, column: 4 },
      discountRate: { row: 6, column: 4 },
      ncpCode: { row: 7, column: 4 },
      image: { row: 4, column: 6 }
    },

    cellInterval: 3
  }
}
